<template>
  <div class="no-content">
    <span> {{ description }} </span>
  </div>
</template>

<script>
export default {
  props: {
    description: { type: String, default: 'Nenhum dado encontrado!' },
  },
}
</script>

<style lang="scss" scoped>
.no-content {
  padding: 1rem;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: 500;
    color: $black-1;
    letter-spacing: 0.06em;
  }

  @media (max-width: 450px) {
    span {
      font-size: 0.8em;
    }
  }
}
</style>
